
import Groups from './Groups/Routes';
import Ledgers from './Ledgers/Routes';
import NoteSheet from './NoteSheet/Routes';
import CostCenter from './CostCenter/Routes';
import PreSanction from './PreSanction/Routes';

export default [...Ledgers, ...Groups, ...CostCenter, ...NoteSheet, ...PreSanction];